import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';


@Component({
  selector: 'app-aeronave-pf',
  templateUrl: './aeronave-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./aeronave-pf.component.css']
})
export class AeronavePfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.aeronave===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.aeronave===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
